import React, { useEffect, useState } from "react";
import { withRouter, useLocation, useHistory } from "react-router-dom";
import { config } from "../../../../../../../config";
import Popup from 'reactjs-popup';
import "./../LeagueGroups.css"
import { COLORS, BACK_DROP_FALSE, TBD } from "../../../../../../../Util/helper";
import WarningDialogue from "../../../../../../../Util/WarningDialogue";
import add from "../../../../../../../assets/add-icon.svg";
import deleteIcon from "../../../../../../../assets/delele.svg";
import infoIcon from "../../../../../../../assets/info.png";
import reschedule from "../../../../../../../assets/reschedule.svg";
import axiosApi from "../../../../../../../core/interceptor/interceptor";
import "./WeeklyMatch.css";
import CustomSelect from "../../../../../../../Util/CustomSelect/CustomSelect";
import AddMatchup from "./AddMatchup/AddMatchup";
import getSearchParam from "../../../../../../../hooks/UrlSearchParam";
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { messages } from '../../../../../../../messages';
import { toast } from "react-toast";
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

function WeeklyMatch(props) {
  const [weeks, setWeeks] = useState([]);
  const [pWeeks, setPlainWeeks] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState({});
  const [weekData, setWeekData] = useState([]);
  const [leagueId, setLeagueId] = useState(0);
  const [leagueInfo, setLeagueInfo] = useState({});
  const [matchup, setMatchup] = useState('');
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popupContent, setPopupContent] = useState(false);
  const [scoreUpdated, setScoreUpdated] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [sameFieldsErr, setSameFieldsErr] = useState([]);
  const [openSameTeamInfo, setOpenSameTeamInfo] = useState(false);
  const [sameTeamInfo, setSameTeamInfo] = useState({});
  const [tbd, setTbdTime] = useState({});
  const [locationTbd, setLocationTbd] = useState({});
  const search = useLocation().search;
  const season_id = new URLSearchParams(search).get('season_id');
  const history = useHistory();
  const [ showSmsPopup ,setShowSmsPopup] = useState(false);

  useEffect(() => {
    const leagueId_ = getSearchParam(props.location).get('leagueId');
    if (leagueId_ > 0) {
      setLeagueId(leagueId_);
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (leagueId > 0) {
      getLeagueInfo();
    }
    //eslint-disable-next-line
  }, [leagueId]);

  const getLeagueInfo = () => {
    axiosApi.get(`${config.apiUrl}/leagues/time/team/location/field/${leagueId}`)
      .then((response) => {
        const data = response.data.data;
        let weekData = [];
        if (response.data && response.data.weekInfo && response.data.weekInfo.length) {
          weekData = [...response.data.weekInfo.map(x => ({ id: x, title: `Week ${x}` }))];
        } else {
          let i = +data.no_of_weeks || 0;
          do {
            weekData = [...weekData, ...[{ id: i, title: `Week ${i}` }]]
            i -= 1;
          } while (i > 0);
          weekData = weekData.reverse();
        }
        if (weekData.length) {
          setWeeks(weekData);
          setSelectedWeek(weekData[0]);
          setPlainWeeks(weekData.map(x => ({ ...x, title: "" + x.id })));
        }
        if (response.data && response.data.teamData) {
          response.data.teamData = [...[{ id: 0, name: 'Select matchup' }], ...response.data.teamData];
          response.data.teamData = response.data.teamData.map((v, i) => ({ ...v, color: COLORS[i], title: v.name }));
        }
        setMatchup({
          ...response.data,
          times: [{ time: null, title: TBD.name }, ...response.data.times]
        });

        if (response.data?.tbd) {
          setTbdTime(response.data.tbd);
          setLocationTbd({ id: response.data.tbd.parent_id, title: 'TBD' });
        }
      })
      .catch((err) => {
      })
  }

  const onWeekSelect = (data, type) => {
    if (data && data.title) {
      setSelectedWeek(data);
      setSameFieldsErr([]);
      setScoreUpdated(false);
    }
  }

  useEffect(() => {
    if (selectedWeek && selectedWeek.id && matchup) {
      getWeeklyMatchup()
      getWeekData(selectedWeek.id)
    }
    //eslint-disable-next-line
  }, [selectedWeek, matchup]);

  const getWeeklyMatchup = (week = '') => {
    if (!week) {
      week = selectedWeek.id
    }
    axiosApi.get(`${config.apiUrl}/leagues/active/weekly/matchup/${leagueId}/${week}`)
      .then((response) => {
        let data = response.data && response.data.data ? response.data.data : [];
        let schedulingCount = response.data && response.data.schedulingCount && response.data.schedulingCount > 0 ? response.data.schedulingCount : 0;
        setLeagueInfo(response?.data?.league || {});
        if (data.length) {
          data.forEach(element => {
            element.date = moment(element.date, 'YYYY-MM-DD').toDate();
            element.date_normal = moment(element.date, 'YYYY-MM-DD');
            element.time = element.time ? moment(element.time, 'HH:mm').format('hh:mm A') : null
          });
        }
        if (Array.isArray(data)) {
          data.forEach((d) => {
            const fields = [].concat.apply([], matchup.locationFields.map(x => x.fields)).filter(x => +x.parent_id === +(d?.location_id || 0));
            d['fields'] = fields;
          });
        }
        if (!data.length) {
          if (schedulingCount) {
            if (weeks) {
              const selectedIndex = weeks.findIndex(w => w.id === week);
              if (selectedIndex !== -1 && weeks[selectedIndex + 1]) {
                getWeeklyMatchup(weeks[selectedIndex + 1].id);
                return;
              }
            }
            // Either this is the last week in the list, or selectedIndex was -1.
            // All available weeks have been checked and are empty — show the message.
            setErrorMessage(messages.noScheduling);
          } else {
            setErrorMessage(messages.noScheduling);
          }
        }
        setWeekData(data);
      }).catch(err => {
      })
  }

  const closeModal = (data) => {
    setOpen(false);
  }

  const modifyWeekData = (index, resp, locationChange) => {
    if (leagueInfo.status === 'active' && ['team1_score', 'team2_score'].includes(resp.type) && resp.data > 0) {
      console.log("HHHH");
      setScoreUpdated(true);
    }

    switch (resp.type) {
      case 'team1_score':
      case 'team2_score':
      case 'field_id':
        if (!resp.data) {
          weekData[index][resp.type] = null;
          setWeekData([...weekData]);
        }
        break;
    }

    if (resp && resp.data) {
      weekData[index][resp.type] = resp.data;
      if (locationChange) {
        const fields = [].concat.apply([], matchup.locationFields.map(x => x.fields)).filter(x => +x.parent_id === +resp.data);

        if (resp.data === tbd.parent_id) {
          weekData[index]['field_id'] = tbd.id;
        }

        weekData[index]['fields'] = fields;
      }
      if (resp.type === 'date' && resp.data) {
        weekData[index]['date_normal'] = moment(resp.data).format('YYYY-MM-DD');
      }
      setWeekData([...weekData]);
    }
    setOpen(false);
  }

  const colorCode = (id) => {
    let color = '';
    if (id && matchup && matchup.teamData) {
      color = matchup.teamData.find(x => +x.id === +id) ? matchup.teamData.find(x => +x.id === +id).color : '';
    }
    return color;
  }

  const teamName = (id) => {
    let name = '--';
    if (id && matchup && matchup.teamData) {
      name = matchup.teamData.find(x => +x.id === +id) ? matchup.teamData.find(x => +x.id === +id).name : '--';
    }
    return name;
  }

  const locationName = (id) => {
    let name = '';
    if (id && matchup && matchup.locationFields) {
      name = matchup.locationFields.find(x => +x.id === +id) ? matchup.locationFields.find(x => +x.id === +id).title : '';
      if (id === tbd.parent_id) {
        name = tbd.title;
      }
    }
    return name;
  }

  const fieldName = (id, parent_id) => {
    let name = '';
    if (id && matchup && matchup.fields) {
      name = matchup.fields.find(x => (+x.id === +id && +x.parent_id === +parent_id)) ? matchup.fields.find(x => (+x.id === +id && +x.parent_id === +parent_id)).title : '';
      if (id === tbd.id) {
        name = tbd.title;
      }
    }
    return name;
  }

  const removeMatchup = (schedule) => {
    const combinedDateTime = moment(`${schedule.date_normal} ${schedule.time}`, 'YYYY-MM-DD hh:mm A');
    const currentDateTime = moment();
    
    let showSmsPopup = false;
    if (leagueInfo?.enable_sms_reminder && leagueInfo?.enable_regular_reminder && !combinedDateTime.isBefore(currentDateTime)) {
      showSmsPopup = true;
    }
    setOpenWarningPopup(true);
    setPopupContent({
      header: 'Remove',
      description: "Are you sure, you want to remove this matchup?",
      type: showSmsPopup ? "delete-schedule" : "",
      icon: faExclamationCircle,
      action: (flag) => {
        if (schedule.id) {
          let url = `${config.apiUrl}/leagues/active/weekly/matchup/${schedule.id}`;
          if (showSmsPopup) {
            url += `?send_sms=${flag ? 'yes' : 'no'}`
          }
          axiosApi.delete(url)
            .then(() => {
              setOpenWarningPopup(false);
              getWeeklyMatchup();
            }).catch((err) => {
              setOpenWarningPopup(false);
            })
        }
      }
    })
  }

  const rescheduleMatchup = (schedule) => {
    const { id, league_id } = schedule;
    const combinedDateTime = moment(`${schedule.date_normal} ${schedule.time}`, 'YYYY-MM-DD hh:mm A');
    const currentDateTime = moment();
    
    let showSmsPopup = false;
    if (leagueInfo?.enable_sms_reminder && leagueInfo?.enable_regular_reminder && !combinedDateTime.isBefore(currentDateTime)) {
      showSmsPopup = true;
    }
    if (matchup && matchup.data && matchup.data.status === 'active') {
      setOpenWarningPopup(true);
      setPopupContent({
        header: 'Reschedule',
        description: "Are you sure, you want to reschedule the matchup? All the upcoming matches will be rescheduled and moved ahead by 1 week.",
        type:showSmsPopup ? "reschedule": "",
        icon: faExclamationCircle,
        action: (res) => {
          if (league_id) {
            axiosApi.put(`${config.apiUrl}/leagues/active/weekly/matchup/reschedule/${id}/${league_id}/${selectedWeek.id}`, { send_reschedule_message: res })
              .then((response) => {
                let weekData = [];
                if (response.data && response.data.data && response.data.data.length) {
                  weekData = [...response.data.data.map(x => ({ id: x, title: `Week ${x}` }))];
                }
                if (weekData.length) {
                  setWeeks(weekData);
                  setPlainWeeks(weekData.map(x => ({ ...x, title: "" + x.id })));
                }
                setOpenWarningPopup(false);
                getWeeklyMatchup();
              }).catch((err) => {
                setOpenWarningPopup(false);
              })
          }
        }
      })
    }
  }

  const bulkUpdate = (skip_reschedule_check, send_reschedule_message) => {
    let updatedData = [...JSON.parse(JSON.stringify(weekData))];
    const err = [];
    if (updatedData) {
      let sameFields = false;
      updatedData.forEach((element, k) => {
        element.time = element.time && element.time != TBD.name ? moment(element.time, 'hh:mm A').format('HH:mm') : null
        element.winner_id = element.team1_score && (Number(element.team1_score) > Number(element.team2_score)) ? element.team1_id : (Number(element.team1_score) < Number(element.team2_score) ? element.team2_id : null);
        element.is_completed = !!(element.team1_score || element.team2_score);
        element.date = element.date ? moment(element.date).format('YYYY-MM-DD') : null;
        if(element.team1_id > 0 && element.team2_id) {
          const sameInfo = updatedData.find((x, i) => i !== k && x.field_id != tbd.id && x.time === element.time && x.field_id === element.field_id && element.date === x.date && x.location_id === element.location_id);
          if (sameInfo) {
            sameFields = true;
            err[k] = { error: true };
          } else {
            err[k] = { error: false };
          }
        }
      });
      if (!sameFields) {
        setSameFieldsErr([]);
        axiosApi.put(`${config.apiUrl}/leagues/active/weekly/matchup/bulk/update`, { schedule: updatedData, skip_reschedule_check, send_reschedule_message })
          .then((response) => {
            
            if(response?.data?.data?.reschedule) {
              setOpenWarningPopup(true);
              setPopupContent({
                header: 'Confirm',
                description: "Would like to send reschedule message?",
                icon: faExclamationCircle,
                type: 'reschedule',
                action: (res) => {
                  bulkUpdate(true, res);
                  setOpenWarningPopup(false);
                }
              });

            } else {
              if (scoreUpdated) {
                axiosApi.get(`${config.apiUrl}/leagues/schedule/playoff/bracket/${leagueId}/false`);
              }
            }
          }).catch(err => {
            if (err?.response?.data?.data?.sameSchdeule && err?.response?.data?.data?.sameSchdeule.length > 0) {
              const sameFieldsErr = [];
              for (const iterator of err.response.data.data.sameSchdeule) {
                sameFieldsErr[+iterator.key] = { error: true, league: iterator?.conflict?.league?.name };
              }
              setSameFieldsErr(sameFieldsErr);
            }
          })
        
      } else {
        setSameFieldsErr(err);
        toast.error('Please check scheduling, Conflict found for location and fields');
      }

    }
  }

  const onWeekChange = (data, type) => {
    if (data && data.title) {
      if (type && type.id) {
        const payload = { id: type.id, week: data.id , send_reschedule_message: data.flag };
        axiosApi.patch(`${config.apiUrl}/leagues/active/weekly/matchup/update`, payload)
          .then(() => {
            setSelectedWeek({ id: data.id, title: `Week ${data.id}` });
          }).catch((err) => {
            setOpenWarningPopup(false);
          })
      }
    }
  }

  const getWeekData = (week) => {
    const nWeeks = weeks.map(x => ({ ...x, title: "" + x.id })).filter(x => +x.id !== +week);
    setPlainWeeks(nWeeks);
  }

  const checkProperSchedule = () => {
    setOpenWarningPopup(true);
    setPopupContent({
      header: 'Warning',
      description: messages.rescheduleMatchup,
      icon: faExclamationCircle,
      action: () => {
        setOpenWarningPopup(false);
        axiosApi.get(`${config.apiUrl}/teams/check/scheduling/${leagueId}`)
          .then((response) => {
            if (!response.data.properScheduling) {
              setOpenWarningPopup(true);
              setPopupContent({
                header: 'Confirm',
                description: response.data.message,
                icon: faExclamationTriangle,
                action: () => {
                  setOpenWarningPopup(false);
                  setTimeout(() => {
                    history.push({
                      pathname: `/admin/leagues/teams/league-settings`,
                      search: `?leagueId=${leagueId}&selected=true${(season_id) ? `&season_id=${season_id}` : ''}`,
                    })
                  }, 100);
                }
              });
            } else {
              reScheduleWeeklyMatchup();
            }
          })
          .catch((err) => {
            reScheduleWeeklyMatchup();
          })
      }
    });
  }
  const reScheduleWeeklyMatchup = () => {
    axiosApi.get(`${config.apiUrl}/leagues/schedule/weekly/matchup/${leagueId}/true`)
      .then((response) => {
        setErrorMessage(response.data.message);
        let weekData = [];
        if (response.data && response.data.weekInfo && response.data.weekInfo.length) {
          weekData = [...response.data.weekInfo.map(x => ({ id: x, title: `Week ${x}` }))];
        }
        if (weekData.length) {
          setWeeks(weekData);
          setPlainWeeks(weekData.map(x => ({ ...x, title: "" + x.id })));
        }
        setTimeout(() => {
          if (weekData) {
            setSelectedWeek(weekData[0]);
            getWeeklyMatchup(weekData[0].id);
          }
        }, 300)
        if (response.data.conflicts) {
          setOpenWarningPopup(true);
          setPopupContent({
            header: 'Warning',
            description: messages.conflictedFields,
            icon: faExclamationCircle,
            action: () => {
              setOpenWarningPopup(false);
            }
          });
        }
      })
  }

  const movedToEnd = () => {
    let showSmsPopup = false;
    if (weekData.length) {
      weekData.forEach((schedule) => {
        const combinedDateTime = moment(`${schedule.date_normal} ${schedule.time}`, 'YYYY-MM-DD hh:mm A');
        const currentDateTime = moment();
        if (leagueInfo?.enable_sms_reminder && leagueInfo?.enable_regular_reminder && !combinedDateTime.isBefore(currentDateTime)) {
            showSmsPopup = true;
          }
      })
    }
    
    if (matchup && matchup.data && matchup.data.status === 'active') {
      setOpenWarningPopup(true);
      setPopupContent({
        header: 'Move week',
        description: `Are you sure, you want to move week ${selectedWeek.id} to the end of this schedule?`,
        icon: faExclamationCircle,
        type: showSmsPopup ? "reschedule" : "",
        action: (res) => {
          if (leagueId) {
            axiosApi.put(`${config.apiUrl}/leagues/active/weekly/matchup/move/week/${leagueId}/${selectedWeek.id}`, { send_reschedule_message: res })
              .then((response) => {
                let weekData = [];
                if (response.data && response.data.data && response.data.data.length) {
                  weekData = [...response.data.data.map(x => ({ id: x, title: `Week ${x}` }))];
                }
                if (weekData.length) {
                  setWeeks(weekData);
                  setPlainWeeks(weekData.map(x => ({ ...x, title: "" + x.id })));
                }
                setOpenWarningPopup(false);
                getWeeklyMatchup();
              }).catch((err) => {
                setOpenWarningPopup(false);
              })
          }
        }
      })
    }
  }
  
  useEffect(() => {
    let showSmsPopup = false;
    if (weekData.length) {

      for (const schedule of weekData) {
        const combinedDateTime = moment(`${schedule.date_normal} ${schedule.time}`, 'YYYY-MM-DD hh:mm A');
        const currentDateTime = moment();
        if (leagueInfo?.enable_sms_reminder && leagueInfo?.enable_regular_reminder && !combinedDateTime.isBefore(currentDateTime)) {
          showSmsPopup = true;
        }
      }
    }
    setShowSmsPopup(showSmsPopup);
  }, [weekData, leagueInfo])
  return (
    <>
      {
        weekData &&
        weekData.length > 0 &&
        <>
          <div className="groups-wrapper weeklyMatchup-wrapper">
            <div className="common-block-matchup">
              <div className="heading-wrapper left-block">
                <h2 className="heading">Weekly Matchups</h2>
                <p>Select Week to view matchups</p>
                <CustomSelect
                  uniqueKey={'weeks-key'}
                  data={weeks}
                  placeholder={selectedWeek.title ? selectedWeek.title : 'Select week'}
                  type={'week'}
                  onSelect={onWeekSelect}
                  selector="title"
                />
              </div>
              {
                matchup &&
                matchup.data &&
                matchup.data.status === 'active' &&
                <div className="right-block">
                  <div className="schedule-button-wrapper add-margin">
                    <button className="btn btn-primary" onClick={() => movedToEnd()}>Move to End</button>
                    <button className="btn btn-primary" onClick={() => checkProperSchedule()}>Re-Schedule</button>
                  </div>
                </div>
              }
            </div>
            <div className="matchup-table">
              <div className="matchup-header">
                <div className="matchup-row">
                  <div className="matchup-col">
                    <span>Date</span>
                  </div>
                  <div className="matchup-col">
                    <span>Time</span>
                  </div>
                  <div className="matchup-col">
                    <span>Field</span>
                  </div>
                  <div className="matchup-col">
                    <span>Location</span>
                  </div>
                  <div className="matchup-col match-col">
                    <span>Matchup</span>
                  </div>
                  <div className="matchup-col">
                    <span>Score</span>
                  </div>
                  <div className="matchup-col date-col">
                    <span></span>
                  </div>
                </div>
              </div>
              <div className="matchup-body" key={`selected-week -${selectedWeek.id}`}>
                {
                  weekData &&
                  selectedWeek &&
                  selectedWeek.id &&
                  weekData.map((val, index) => (
                    <div className="matchup-row" key={index}>
                      <div className="matchup-col">
                        <div className={`date-blk ${sameFieldsErr && sameFieldsErr[index] && sameFieldsErr[index].error ? 'error-date' : ''}`} >
                          <DatePicker
                            placeholderText={'MM/DD/YYYY'}
                            minDate={new Date()}
                            selected={val.date}
                            onChange={(date) => modifyWeekData(index, { type: 'date', data: date })}
                          />
                          {
                            sameFieldsErr && sameFieldsErr[index] && sameFieldsErr[index].error &&
                            <div className="error same-match">
                              {
                                sameFieldsErr[index].league ?
                                  <>Time Conflict with other league  <img src={infoIcon} className="info-icon" title={sameFieldsErr[index].league} onClick={() => { setOpenSameTeamInfo(true); setSameTeamInfo(sameFieldsErr[index]); }} /></>
                                  :
                                  <>Same match timing conflict.</>
                              }
                            </div>
                          }
                        </div>

                      </div>

                      <div className={`matchup-col${val.time === 'TBD' ? ' bg-red' : ''}`}>
                        <CustomSelect
                          uniqueKey={`time-level-key-${index}`}
                          data={matchup?.times}
                          placeholder={val.time ? val.time : TBD.name}
                          type={'time'}
                          onSelect={(time) => modifyWeekData(index, { type: 'time', data: time?.title })}
                          selector="title"
                        />
                      </div>
                      <div className={`matchup-col${!val.field_id ? ' bg-red' : ''}`}>
                        <CustomSelect
                          uniqueKey={`field-level-key-${index}`}
                          data={[tbd, ...val?.fields]}
                          placeholder={val.field_id ? fieldName(val.field_id, val.location_id) : TBD.name}
                          type={'field_id'}
                          onSelect={(field) => field && modifyWeekData(index, { type: 'field_id', data: field?.id })}
                          selector="title"
                        />
                      </div>
                      <div className="matchup-col">
                        <CustomSelect
                          uniqueKey={`location-level-key-${index}`}
                          data={[locationTbd, ...matchup?.locationFields]}
                          placeholder={val.location_id ? locationName(val.location_id) : 'Select location'}
                          type={'location_id'}
                          onSelect={(location) => location && modifyWeekData(index, { type: 'location_id', data: location?.id }, true)}
                          selector="title"
                        />
                      </div>
                      <div className="matchup-col match-col">
                        <div className="select-field">
                          <CustomSelect
                            uniqueKey={`team-level-key-${index}`}
                            data={matchup?.teamData}
                            placeholder={val.team1_id ? teamName(val.team1_id) : 'Select matchup'}
                            type={'team1_id'}
                            onSelect={(team) => modifyWeekData(index, { type: 'team1_id', data: team?.id })}
                            selector="title"
                          />
                          <span className="bottom-blk" style={{ background: colorCode(val.team1_id) }}>
                          </span>
                        </div>
                        <div className="select-field">
                          <CustomSelect
                            uniqueKey={'play-level-key'}
                            data={matchup?.teamData}
                            placeholder={val.team2_id ? teamName(val.team2_id) : 'Select matchup'}
                            type={'team2_id'}
                            onSelect={(team) => modifyWeekData(index, { type: 'team2_id', data: team?.id })}
                            selector="title"
                          />
                          <span className="bottom-blk" style={{ background: colorCode(val.team2_id) }}></span>
                        </div>
                      </div>
                      {
                        val.team1_id > 0 &&
                        val.team2_id > 0 &&
                        <div className="matchup-col">
                          <div className="input-row">
                            <div className="input-field">
                              <input type="number" onWheel={(e) => e.target.blur()} value={val.team1_score || val.team1_score === 0 ? val.team1_score : ''} onChange={(e) => modifyWeekData(index, { type: 'team1_score', data: e.target.value })} />
                            </div>
                            <label className="checkbox" key={`team2-${val.id}`}>
                              Forfeit
                              <input type="checkbox" value={val.team1_forfeit > 0 ? true : false} defaultChecked={val.team1_forfeit ? true : false} onChange={() => {
                                weekData[index].team1_forfeit = weekData[index].team1_forfeit === 1 ? 0 : 1;
                                modifyWeekData(index, { type: 'team1_forfeit', data: weekData[index].team1_forfeit })
                              }} />
                              <span className="checkmark"></span>
                            </label>
                          </div>

                          <div className="input-row">
                            <div className="input-field">
                              <input type="number" onWheel={(e) => e.target.blur()} value={val.team2_score || val.team2_score === 0 ? val.team2_score : ''} onChange={(e) => modifyWeekData(index, { type: 'team2_score', data: e.target.value })} />
                            </div>
                            <label className="checkbox" key={`team1-${val.id}`}>
                              Forfeit
                              <input type="checkbox" value={val.team2_forfeit ? true : false} defaultChecked={val.team2_forfeit ? true : false} onChange={() => {
                                weekData[index].team2_forfeit = weekData[index].team2_forfeit === 1 ? 0 : 1;
                                modifyWeekData(index, { type: 'team2_forfeit', data: weekData[index].team2_forfeit })
                              }} />
                              <span className="checkmark"></span>
                            </label>
                          </div>
                        </div>
                      }
                      {
                        val.team1_id > 0 &&
                        val.team2_id > 0 &&
                        <div className="matchup-col date-col">
                          <div className="btn-action">
                            <button className="icon-btn-action" title="Delete">
                              <span onMouseDown={() => removeMatchup(val)}>
                                <img src={deleteIcon} />
                              </span>
                            </button>
                            <button className="icon-btn-action" title="Reschedule">
                              {
                                matchup &&
                                matchup.data &&
                                matchup.data.status === 'active' &&
                                <span onMouseDown={() => rescheduleMatchup(val)}>
                                  <img src={reschedule} />
                                </span>
                              }
                            </button>
                          </div>
                          <span>Move To Week</span>
                          <div className="">
                            <CustomSelect
                              uniqueKey={`weeks-key-matchup`}
                              data={pWeeks}
                              placeholder={'Select'}
                              selectedData={null}
                              type={'week'}
                              onSelect={(e) => onWeekChange(e, val)}
                              selector="title"
                              shoWarning={true}
                              showSmsPopup={showSmsPopup}
                            />
                          </div>
                        </div>
                      }
                    </div>
                  ))
                }
              </div>
            </div>
            <div className="btn-blk">
              <button className="btn" onClick={() => bulkUpdate()}>Save Changes</button>
              {
                selectedWeek &&
                selectedWeek.id &&
                <button className="btn" onClick={() => setOpen(o => !o)}><img src={add} alt="add-icon" />{`Add Week ${selectedWeek.id} Matchup`}</button>
              }

            </div>
            <Popup open={open} closeOnDocumentClick={BACK_DROP_FALSE}>
              <AddMatchup closeModal={closeModal} matchup={matchup} leagueId={leagueId} week={selectedWeek.id} refresh={() => getWeeklyMatchup()} />
            </Popup>
          </div>
          <WarningDialogue
            isOpen={openWarningPopup}
            header={popupContent.header}
            description={popupContent.description}
            icon={popupContent.icon}
            action={popupContent.action}
            type={popupContent?.type || ''}
            onClose={() => setOpenWarningPopup(false)}
          />
          <Popup open={openSameTeamInfo} closeOnDocumentClick={BACK_DROP_FALSE}>
            <div className="modal">
              <div className="modal-header">
                <h2>League</h2>
                <span className="close" onClick={() => setOpenSameTeamInfo(false)}>×</span>
              </div>
              <div className="modal-body">
                <div className="warning-message-field">
                  <p>{sameTeamInfo.league}</p>
                </div>
              </div>
              <div className="modal-footer d-flex">
                <button onClick={() => setOpenSameTeamInfo(false)}>Ok</button>
              </div>
            </div>
          </Popup>
        </>
      }
      {
        errorMessage &&
        errorMessage !== '' &&
        <div className="groups-wrapper weeklyMatchup-wrapper">
          <div className="no-record">
            <h3>
              {errorMessage}
            </h3>
          </div>
        </div>
      }
    </>
  );
}

export default withRouter(WeeklyMatch);
